import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrls: ['./user-dialog.component.scss']
})
export class UserDialogComponent implements OnInit {
  form: FormGroup;
  isEditMode: boolean;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { user?: User; isEdit: boolean }
  ) {
    this.isEditMode = data.isEdit;
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm(): void {
    this.form = this.fb.group({
      email: [this.data?.user?.email || '', [Validators.required, Validators.email]],
      firstName: [this.data?.user?.firstName || '', [Validators.required]],
      lastName: [this.data?.user?.lastName || '', [Validators.required]],
      roles: [this.data?.user?.roles || [], Validators.required],
      password: [''],
      isActive: [this.data?.user?.isActive || true]
    });

    if (this.isEditMode) {
      this.form.get('password')?.clearValidators();
    } else {
      this.form.get('password')?.setValidators([Validators.required, Validators.minLength(6)]);
    }

    this.form.get('password')?.updateValueAndValidity();
  }

  onSubmit(): void {
    if (this.form.valid) {
      const formValue = this.form.getRawValue(); // Use getRawValue to include disabled controls
      this.dialogRef.close({
        ...formValue,
        id: this.data.user?.id
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
} 